// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Skillet$LiteracyplanetTupperware from "./Skillet.res.mjs";
import * as FlagsContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/FlagsContext.res.mjs";
import * as PilotStemHeading$LiteracyplanetTupperware from "../v3/PilotStemHeading.res.mjs";

function SkilfulStemHeading(props) {
  var children = props.children;
  var hasFlag = FlagsContext$LiteracyplanetClientFlags.use();
  if (Curry._1(hasFlag, {
          NAME: "Unleash",
          VAL: "temp_hasPilotLayout"
        })) {
    return React.createElement(PilotStemHeading$LiteracyplanetTupperware.make, {
                children: children
              });
  } else {
    return React.createElement("div", {
                className: Skillet$LiteracyplanetTupperware.SkilfulStemHeading.className
              }, children);
  }
}

var make = SkilfulStemHeading;

var $$default = SkilfulStemHeading;

export {
  make ,
  $$default as default,
}
/* react Not a pure module */
